export const en = {
    'error-message': 'The request failed, please try again later.',
    'freelancer-page-header': 'Yandex.Direct expert',
    'withdraw-coop-success':
        "You've revoked your request to this expert. You can choose a different expert to work with or re-send the request to this contact."
};
